import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const AI_GENERATE_ACTIONS_FIELD_NAME = 'aiGeneratedActions';
export const AI_GENERATE_ACTIONS = registerMutation({
  fieldName: AI_GENERATE_ACTIONS_FIELD_NAME,
  args: ['userInput', 'objectTypeId', 'startingActionId'],
  fetcher: ({
    userInput,
    objectTypeId,
    startingActionId
  }) => {
    return http.post('opshub-ai/v0/workflows-copilot/generation/actions', {
      timeout: 30000,
      data: {
        userInput,
        objectTypeId,
        startingActionId
      }
    }).catch(error => {
      const errorWithInfo = error;
      reportError({
        error: errorWithInfo,
        tags: {}
      });
    });
  }
});
export const AI_GENERATE_ENROLLMENT_FIELD_NAME = 'aiGenerateEnrollment';
export const AI_GENERATE_ENROLLMENT = registerMutation({
  fieldName: AI_GENERATE_ENROLLMENT_FIELD_NAME,
  args: ['filterGroupInputs', 'objectTypeId'],
  fetcher: data => {
    return http.post('opshub-ai/v0/workflows-copilot/generation/enrollment-criteria', {
      data,
      timeout: 30000
    }).catch(error => {
      const errorWithInfo = error;
      reportError({
        error: errorWithInfo,
        tags: {}
      });
    });
  }
});